export default "__VITE_ASSET__DRMo8bQG__"